var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 758,
    height: 480,
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 138h758v480H-1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0071BB",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(1 -138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m431.567 156.481 170.735 111.028s86.991 46.695 9.68 88.554c0 0-35.422 29.67-149.81 19.999 0 0-58.003-9.923-88.602-30.83 0 0-40.283-21.407-8.045-40.654 0 0 48.323-16.117-37.056-24.178 0 0-88.601-9.671-125.662-3.226 0 0-62.814 3.226-91.807 12.897l214.241-139.587c0 .006 54.78-29.467 106.326 5.997Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.127 333.806S78.32 300.04 179.934 298.43c0 0 62.944-3.228 98.409 8.014 0 0-59.683 70.809 40.373 125.543 0 0 61.297 43.549 188.743 51.602 0 0 79.071 8.021 114.542 3.178L451.009 594.719s-65.114 60.426-164.58-17.741L29.899 409.447c0 .006-69.377-30.533 3.228-75.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 381.795s119.424 62.745 272.715 16.117c0 0 61.315-9.618 98.438-57.912 0 0 71.04 32.178 20.985 67.573 0 0-3.211 19.291-125.864 35.403 0 0-85.541 4.833-124.278-6.494.006 0-111.364-19.286-141.996-54.687Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/경북도청.a924abdae24d95b4ba06168a05b7a636.svg";
export { ForwardRef as ReactComponent };